module.exports = __webpack_public_path__ + "img/161.03befb14.jpg";